import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  reportsList: {},
  eWalletReport: {
    columns: [],
    data: [],
  },
  eWalletPopupReport: {
    columns: [],
    data: [],
  },
  eWalletIndividualReport: {
    columns: [],
    data: [],
  },
  visitorHistoryList: {
    list: {
      data: [],
      total: 0,
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
